import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class TimeZoneSearchModel extends SearchModel<any> {
    constructor(injector: Injector) {
        super(injector);
    }
}
